module.exports = __webpack_public_path__ + "a00919562de72cb0a586678f31860089.svg";